import { CampaignMetaVideo } from '@interfaces';

const MP4_TYPE = 'video/mp4';
const MUX_STREAM_HOST = 'https://stream.mux.com/';

// api-v2 names the rendition after the asset's maxResolution and omits the source until it is
// ready, so reading its entry keeps one owner of both decisions. The host narrows it to the
// rendition: `sources` also carries the original upload as video/mp4, unbounded in size.
export const getMuxMp4Url = (video?: CampaignMetaVideo): string | null =>
  video?.sources?.find(
    (source) =>
      source?.type === MP4_TYPE && source?.src?.startsWith(MUX_STREAM_HOST)
  )?.src ?? null;
